import { Outlet } from "react-router-dom";

import { type ReactNode } from "react";
import { Toaster } from "@/components/ui/toaster";
import { PublicHeader } from "./PublicHeader";
import { PublicFooter } from "./PublicFooter";
import { Box } from "@chakra-ui/react";


type PublicLayoutProps = {
  children?: ReactNode;
};

export const PublicLayout = ({ children }: PublicLayoutProps) => {
  return (
    <Box
      minHeight="100vh" // full viewport height
      display="flex"
      flexDirection="column"
      // bg="button.cta.gradient"
      bg="bg.header"
    >
      <PublicHeader />
      <Box
        as="main"
        flex="1" // take all available space
        display="flex"
        flexDirection="column"
        justifyContent="center" // vertical centering
        alignItems="center"    // horizontal centering if needed
        padding="2rem"
        maxWidth="800px"
        margin="0 auto"
        minHeight="0" // allow flex grow to work properly
      >
        <Toaster />
        {/* If children exists render it, else render <Outlet /> */}
        {children ?? <Outlet />}
      </Box>
      <PublicFooter />
    </Box>
  );
};
